export const addDisabledField = (nodes = []) => {
  const activeLocationsIds = [];

  const walk = (items, skipChildrenCollecting = false) => {
    return items.map(({ isDisabled, children, ...node }) => {
      const isActive = !isDisabled;
      const hasChildren = Array.isArray(children) && children.length > 0;

      const shouldCollectOnlyTopLevel = isActive && hasChildren;

      if (isActive && !skipChildrenCollecting) {
        activeLocationsIds.push(node.id);
      }

      const transformed = {
        ...node,
        disabled: isDisabled,
        children: children?.length ? walk(children, skipChildrenCollecting || shouldCollectOnlyTopLevel) : [],
      };

      return transformed;
    });
  };

  const processedFacilityStructureData = walk(nodes);

  return { processedFacilityStructureData, activeLocationsIds };
};
